/* Brand landing (templates/collection.brand-*.json). Loaded by more than one
   of its sections, so it runs once.

   Kinds of product (sections/tbc-brand-plate.liquid): where the bar
   overflows, it starts at the first kind and steps to the next every few
   seconds, back to the first after the last; a touch rests it.

   Offers (sections/tbc-brand-offers.liquid): the offers sit side by side and
   slide by one every few seconds (data-autoplay, in seconds; none for
   visitors who ask for reduced motion), held by the pause button, a pointer
   over them or keyboard focus inside them; the segments pick one, the arrows
   and the arrow keys step through them.

   Pagination: the collection's grid closes the page, and its page links swap
   the grid in place, the way the theme's filters already do, instead of
   loading the whole page again. The address keeps no ?page=, so the brand
   rows above (which follow the same pagination, sections/tbc-brand-row.liquid)
   never come back empty on a reload. Without this script the links still
   work, landing on the grid's heading (#tbc-bl-all, snippets/pagination.liquid). */

(function () {
  if (window.TbcBrandLanding) return;
  window.TbcBrandLanding = true;

  function offers(root) {
    if (root.dataset.tbcReady) return;
    var slides = root.querySelectorAll('[data-tbc-offer]');
    var segs = root.querySelectorAll('[data-tbc-offer-go]');
    var track = root.querySelector('.tbc-bl-offers__track');
    var rail = root.querySelector('.tbc-bl-offers__rail');
    var pause = root.querySelector('[data-tbc-offer-pause]');
    if (slides.length < 2 || !rail) return;
    root.dataset.tbcReady = 'true';

    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var seconds = Number(root.getAttribute('data-autoplay')) || 0;
    var current = 0;
    var timer = null;
    var stopped = still || !seconds;
    var held = false;

    root.classList.add('is-sliding');
    slides.forEach(function (slide) { slide.hidden = false; });

    /* The track takes the height of the offer in view, so a short offer
       leaves no empty band under its text. */
    function fit() {
      track.style.height = slides[current].offsetHeight + 'px';
    }
    if (window.ResizeObserver) {
      var watch = new ResizeObserver(fit);
      slides.forEach(function (slide) { watch.observe(slide); });
    } else {
      window.addEventListener('resize', fit);
    }

    function show(index) {
      current = (index + slides.length) % slides.length;
      rail.style.transform = 'translateX(' + (current * -100) + '%)';
      slides.forEach(function (slide, i) {
        /* Off-screen offers can't take focus or be read out. */
        slide.inert = i !== current;
        slide.setAttribute('aria-hidden', i === current ? 'false' : 'true');
      });
      segs.forEach(function (seg, i) {
        if (i === current) seg.setAttribute('aria-current', 'true');
        else seg.removeAttribute('aria-current');
      });
      fit();
    }

    function schedule() {
      clearTimeout(timer);
      if (stopped || held || document.hidden) return;
      timer = setTimeout(function () {
        show(current + 1);
        schedule();
      }, seconds * 1000);
    }

    function setStopped(value) {
      stopped = value;
      if (pause) {
        pause.classList.toggle('is-paused', stopped);
        pause.setAttribute('aria-label', pause.getAttribute(stopped ? 'data-label-play' : 'data-label-pause'));
      }
      schedule();
    }

    root.addEventListener('click', function (event) {
      var go = event.target.closest('[data-tbc-offer-go]');
      var step = event.target.closest('[data-tbc-offer-step]');
      if (go) show(Number(go.getAttribute('data-tbc-offer-go')));
      if (step) show(current + Number(step.getAttribute('data-tbc-offer-step')));
      if (event.target.closest('[data-tbc-offer-pause]')) setStopped(!stopped);
      else if (go || step) schedule();
    });
    root.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowRight') show(current + 1);
      if (event.key === 'ArrowLeft') show(current - 1);
    });
    root.addEventListener('pointerenter', function () { held = true; schedule(); });
    root.addEventListener('pointerleave', function () { held = false; schedule(); });
    root.addEventListener('focusin', function () { held = true; schedule(); });
    root.addEventListener('focusout', function (event) {
      if (root.contains(event.relatedTarget)) return;
      held = false;
      schedule();
    });
    document.addEventListener('visibilitychange', schedule);

    show(0);
    setStopped(stopped);
  }

  function kinds(nav) {
    var list = nav.querySelector('ul');
    if (!list || nav.dataset.tbcReady) return;
    nav.dataset.tbcReady = 'true';
    list.scrollLeft = 0;

    var seconds = Number(nav.getAttribute('data-tbc-kinds')) || 0;
    if (!seconds || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var items = list.querySelectorAll('li');
    var index = 0;
    var restUntil = 0;

    function rest() { restUntil = Date.now() + 10000; }
    list.addEventListener('pointerdown', rest);
    list.addEventListener('wheel', rest, { passive: true });
    list.addEventListener('focusin', rest);

    setInterval(function () {
      var room = list.scrollWidth - list.clientWidth;
      if (room < 2 || document.hidden || Date.now() < restUntil) return;
      index = (index + 1) % items.length;
      var pad = parseFloat(getComputedStyle(list).paddingLeft) || 0;
      var left = items[index].getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft - pad;
      /* Past the last full step, start over from the first kind. */
      if (left > room + 1) {
        index = 0;
        left = 0;
      }
      list.scrollTo({ left: Math.min(left, room), behavior: 'smooth' });
    }, seconds * 1000);
  }

  function start() {
    document.querySelectorAll('[data-tbc-offers]').forEach(offers);
    document.querySelectorAll('[data-tbc-kinds]').forEach(kinds);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  /* Re-bound when the theme editor re-renders the section. */
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-tbc-offers]');
    if (root) offers(root);
  });

  var GRID = '[data-products-grid]';

  function settled(root) {
    /* The cards' entrance animation already ran for the page; these arrive late. */
    root.querySelectorAll('[data-aos]').forEach(function (node) { node.classList.add('aos-animate'); });
  }

  function toHeading() {
    var heading = document.getElementById('tbc-bl-all');
    if (heading) heading.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest(GRID + ' .pagination-custom a[href]');
    if (!link || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    var grid = link.closest(GRID);
    event.preventDefault();

    var url = link.getAttribute('href').split('#')[0];
    grid.classList.add('is-loading');
    fetch(url, { credentials: 'same-origin' })
      .then(function (response) { return response.ok ? response.text() : Promise.reject(); })
      .then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html').querySelector(GRID);
        if (!next) throw new Error('no grid');
        grid.innerHTML = next.innerHTML;
        settled(grid);
        grid.classList.remove('is-loading');
        toHeading();
      })
      .catch(function () {
        window.location.href = link.href;
      });
  });
})();
